export const SecurityErrorCode = {
    // MODA 인증 관련 에러 코드
    INVALID_CREDENTIALS: {
        status: 401,
        code: 'S0001',
        detail: '이메일 또는 비밀번호가 올바르지 않습니다.',
    },
    TOKEN_PAIR_MISMATCH: {
        status: 401,
        code: 'S0002',
        detail: '토큰 쌍이 일치하지 않습니다.',
    },
    // JWT Token related errors
    UNAUTHORIZED: {
        status: 401,
        code: 'S0003',
        detail: '인증이 필요합니다.',
    },
    TOKEN_VALIDATION_FAILED: {
        status: 401,
        code: 'S0004',
        detail: '토큰 검증에 실패했습니다.',
    },
    ACCESS_TOKEN_STILL_VALID: {
        status: 401,
        code: 'S0005',
        detail: '액세스 토큰이 아직 유효합니다.',
    },
    INVALID_ACCESS_TOKEN: {
        status: 401,
        code: 'S0006',
        detail: '유효하지 않은 액세스 토큰입니다.',
    },
    TOKEN_NOT_FOUND: {
        status: 401,
        code: 'S0007',
        detail: '인증 토큰을 찾을 수 없습니다.',
    },
    QUICK_AUTH_FAILED: {
        status: 400,
        code: 'QA_001',
        detail: '계좌 비밀번호가 필요합니다.',
    },
    EMAIL_NOT_FOUND: {
        status: 401,
        code: 'S0008',
        detail: '이메일을 찾을 수 없습니다.',
    },
    INVALID_PASSWORD: {
        status: 401,
        code: 'S0009',
        detail: '비밀번호가 올바르지 않습니다.',
    },
    EXPIRED_QUICK_AUTH: {
        status: 401,
        code: 'QA_002',
        detail: '간편인증이 만료되었습니다.',
    },
    ACCOUNT_TOKEN_VALIDATION_FAILED: {
        status: 401,
        code: 'AT_001',
        detail: '계좌 인증에 실패 했어요.',
    },
    // MODA 커뮤니티 인증 관련 에러 코드
    COMMUNITY_ACCESS_TOKEN_EXPIRED: {
        status: 401,
        code: 'SE006',
        detail: '인증 토큰 기간이 만료되었습니다.',
    },
    COMMUNITY_ACCESS_TOKEN_NOT_FOUND: {
        status: 401,
        code: 'SE007',
        detail: '인증 토큰을 찾을 수 없습니다.',
    },
    BACKOFFICE_TOKEN_VALIDATION_FAILED: {
        status: 401,
        code: 'SE006',
        detail: '토큰 검증에 실패했습니다.',
    },
};
//# sourceMappingURL=SecurityErrorCode.js.map